import React, { useState } from "react";
import { Modal } from "@material-ui/core";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (period: string) => void;
}

const WarrantyPeriodModal = ({ isOpen, onClose, onSelect }: Props) => {
  // 1번 표: 건설업법에 의한 건설공사의 공종별 하자담보 책임기간
  const table1Data = [
    {
      subCategory: "가. 교량",
      description:
        "(1) 교각과 교각사이의 간격이 50m 이상이거나 길이 500m 이상인 교량의 철근콘크리트 또는 철골구조부",
      period: 10,
    },
    {
      subCategory: "",
      description: "(2) 길이 500m 미만인 교량의 철근콘크리트 또는 철골구조부",
      period: 7,
    },
    {
      subCategory: "",
      description:
        "(3) 교량중 교면포장ㆍ이음부ㆍ난간시설 등 (1) 및 (2) 외의 공종",
      period: 2,
    },
    {
      subCategory: "나. 터널",
      description: "(1) 터널(지하철을 포함)의 철근콘크리트 또는 철골구조부",
      period: 10,
    },
    { subCategory: "", description: "(2) (1) 외의 시설", period: 5 },
    {
      subCategory: "다. 철도",
      description:
        "(1) 교량 및 터널을 제외한 철도시설 중 철근콘크리트 또는 철골구조부",
      period: 7,
    },
    { subCategory: "", description: "(2) (1) 외의 시설", period: 5 },
    {
      subCategory: "라. 공항 및 삭도",
      description: "(1) 철근콘크리트 또는 철골구조부",
      period: 7,
    },
    { subCategory: "", description: "(2) (1) 외의 시설", period: 5 },
    {
      subCategory: "마. 항만ㆍ방파제ㆍ사방 또는 간척",
      description: "(1) 철근콘크리트 또는 철골구조부",
      period: 7,
    },
    {
      subCategory: "바. 도로(암거ㆍ측구 및 포장을 포함)",
      description: "",
      period: 2,
    },
    {
      subCategory: "사. 댐",
      description: "(1) 본체 또는 여수로 부분",
      period: 10,
    },
    { subCategory: "", description: "(2) (1) 외의 시설", period: 5 },
    {
      subCategory: "아. 상ㆍ하수도",
      description: "(1) 철근콘크리트 또는 철골구조부",
      period: 7,
    },
    {
      subCategory: "",
      description: "(2) 관로매설 또는 기지설치",
      period: 3,
    },
    {
      subCategory: "자. 하천시설물",
      description: "(1) 하천제방상의 수문",
      period: 5,
    },
    { subCategory: "", description: "(2) (1) 외의 시설", period: 3 },
    { subCategory: "차. 관개수로 또는 매립", description: "", period: 3 },
    { subCategory: "카. 부지정지", description: "", period: 2 },
    {
      subCategory: "타. 조경시설물 또는 조경식재",
      description: "",
      period: 2,
    },
    {
      subCategory: "파. 발전ㆍ가스 또는 산업설비",
      description: "(1) 철근콘크리트 또는 철골구조부",
      period: 7,
    },
    {
      subCategory: "",
      description:
        "(2) 압력이 1㎠당 10kg 이상인 고압가스의 관로(부대기기를 포함) 설치",
      period: 3,
    },
    { subCategory: "", description: "(3) (1) 및 (2) 외의 시설", period: 3 },
    { subCategory: "하. 기타 토목공사", description: "", period: 1 },
    {
      subCategory: "거. 건축",
      description:
        "(1) 대형 공공성 건축물(공동주택ㆍ교정시설ㆍ종합병원ㆍ관광숙박시설ㆍ관람집회시설 또는 대규모 소매점과 16층이상 기타용도의 건축물을 말한다. 이하 (2)목도 같다)의 기둥 또는 내력벽",
      period: 10,
    },
    {
      subCategory: "",
      description:
        "(2) 대형 공공성 건축물 중 기둥 내력벽외의 주요구조부 또는 (1) 외의 건축물중 주요구조부",
      period: 5,
    },
    {
      subCategory: "",
      description:
        "(3) 건축물 중 (1) 및 (2)와 너목의 전문공사를 제외한 기타 부분",
      period: 1,
    },
    { subCategory: "너. 전문공사", description: "(1) 실내의장", period: 1 },
    { subCategory: "", description: "(2) 토공", period: 2 },
    { subCategory: "", description: "(3) 미장ㆍ타일", period: 1 },
    { subCategory: "", description: "(4) 방수", period: 3 },
    { subCategory: "", description: "(5) 도장", period: 1 },
    { subCategory: "", description: "(6) 석공사 또는 조적", period: 2 },
    { subCategory: "", description: "(7) 창호 설치", period: 1 },
    { subCategory: "", description: "(8) 지붕", period: 3 },
    {
      subCategory: "",
      description: "(9) 철물(가목 내지 거목에 해당하는 철골을 제외한다)",
      period: 2,
    },
    {
      subCategory: "",
      description:
        "(10) 철근콘크리트(가목 내지 거목에 해당하는 철근콘크리트를 제외한다)",
      period: 3,
    },
    {
      subCategory: "",
      description:
        "(11) 급배수ㆍ공동구ㆍ지하저수조ㆍ냉난방기ㆍ환기ㆍ공기조화ㆍ자동제어ㆍ가스 또는 배연설비",
      period: 2,
    },
    {
      subCategory: "",
      description: "(12) 승강기 또는 인양기기설비",
      period: 3,
    },
    { subCategory: "", description: "(13) 온실설치공사", period: 2 },
    { subCategory: "", description: "(14) 보우링그라우팅공사", period: 1 },
    { subCategory: "", description: "(15) 건축물 조립공사", period: 1 },
    { subCategory: "", description: "(16) 판금", period: 1 },
    {
      subCategory: "",
      description: "(17) (11) 내지 (16) 외의 건물내 설비",
      period: 1,
    },
  ];

  // 2번 표: 전기공사업법에 의한 전기공사
  const table2Data = [
    {
      subCategory: "가. 터널식 및 개착식전력구 송전설비공사(지중)",
      description: "(1) 철근콘크리트 또는 철골구조부",
      period: 10,
    },
    { subCategory: "", description: "(2) (1) 외의 시설", period: 5 },
    {
      subCategory: "나. 송배전관로 공사(지중)",
      description: "(1) 송전관로공사",
      period: 3,
    },
    { subCategory: "", description: "(2) 배전관로공사", period: 2 },
    { subCategory: "다. 154KW급이상 철탑공사", description: "", period: 3 },
    {
      subCategory: "라. 변전소 설비(전기설비 및 기기설치공사)",
      description: "",
      period: 2,
    },
    { subCategory: "마. 배전설비공사", description: "", period: 2 },
    { subCategory: "바. 기타 전기공사", description: "", period: 1 },
  ];

  // 3번 표: 전기통신공사업법에 의한 전기통신공사
  const table3Data = [
    {
      subCategory: "가. 통신공구공사(터널식 제외)",
      description: "",
      period: 3,
    },
    {
      subCategory:
        "나. 통신시설용 철탑, 케이블 설치공사 및 지하관로공사 교환기 등 통신시설용 기계설치 공사",
      description: "",
      period: 2,
    },
    { subCategory: "다. 기타 전기통신공사", description: "", period: 1 },
  ];

  // 4번 표: 소방법에 의한 소방공사 등
  const table4Data = [
    {
      subCategory: "가. 소방법에 의한 소방공사 등",
      description: "",
      period: 1,
    },
  ];

  const handleSelect = (period: number) => {
    onSelect(`${period}년`);
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  const renderTable = (data: any[], title: string) => (
    <div className="mb-5">
      <h5 className="mb-3 text-primary fw-bold">{title}</h5>
      <div className="table-responsive">
        <table className="table">
          <thead className="table-light">
            <tr>
              <th
                style={{
                  width: "25%",
                  borderLeft: "none",
                  borderRight: "none",
                }}
                className="text-center"
              >
                대분류
              </th>
              <th
                style={{
                  width: "45%",
                  borderLeft: "none",
                  borderRight: "none",
                }}
                className="text-center"
              >
                세부공종
              </th>
              <th
                style={{
                  width: "30%",
                  borderLeft: "none",
                  borderRight: "none",
                }}
                className="text-center"
              >
                하자담보 책임기간(년)
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr
                key={index}
                style={{ cursor: "pointer" }}
                onClick={() => handleSelect(item.period)}
                className="warranty-row"
              >
                <td
                  className="text-center align-middle"
                  style={{ borderLeft: "none", borderRight: "none" }}
                >
                  {item.subCategory || ""}
                </td>
                <td style={{ borderLeft: "none", borderRight: "none" }}>
                  {item.description || ""}
                </td>
                <td
                  className="text-center align-middle"
                  style={{ borderLeft: "none", borderRight: "none" }}
                >
                  <span className="badge bg-primary px-3 py-2">
                    {item.period}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  const renderSimpleTable = (data: any[], title: string) => (
    <div className="mb-5">
      <h5 className="mb-3 text-primary fw-bold">{title}</h5>
      <div className="table-responsive">
        <table className="table">
          <thead className="table-light">
            <tr>
              <th
                style={{
                  width: "70%",
                  borderLeft: "none",
                  borderRight: "none",
                }}
                className="text-center"
              >
                대분류
              </th>
              <th
                style={{
                  width: "30%",
                  borderLeft: "none",
                  borderRight: "none",
                }}
                className="text-center"
              >
                하자담보 책임기간(년)
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr
                key={index}
                style={{ cursor: "pointer" }}
                onClick={() => handleSelect(item.period)}
                className="warranty-row"
              >
                <td
                  className="text-center align-middle"
                  style={{ borderLeft: "none", borderRight: "none" }}
                >
                  {item.subCategory || ""}
                </td>
                <td
                  className="text-center align-middle"
                  style={{ borderLeft: "none", borderRight: "none" }}
                >
                  <span className="badge bg-primary px-3 py-2">
                    {item.period}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      className="d-flex align-items-center justify-content-center"
      style={{ zIndex: 2000 }}
    >
      <div
        className="bg-white rounded-4 mx-3"
        style={{
          maxWidth: "1200px",
          width: "95%",
          maxHeight: "90vh",
          overflowY: "auto",
          outline: "none",
        }}
      >
        {/* 헤더 */}
        <div className="d-flex align-items-center justify-content-between p-4 border-bottom">
          <div className="d-flex align-items-center">
            <span className="material-symbols-outlined me-3 text-primary fs-2">
              schedule
            </span>
            <div>
              <h4 className="mb-1 fw-bold">하자담보 책임기간 선택</h4>
              <p className="text-muted mb-0">
                해당하는 공종을 선택하여 하자보증기간을 설정하세요
              </p>
            </div>
          </div>
          <button
            onClick={handleClose}
            className="btn btn-outline-secondary btn-sm rounded-circle"
            style={{ width: "40px", height: "40px" }}
          >
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>

        {/* 테이블들 */}
        <div className="p-4" style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {renderTable(
            table1Data,
            "1. 건설업법에 의한 건설공사의 공종별 하자담보 책임기간"
          )}
          {renderTable(table2Data, "2. 전기공사업법에 의한 전기공사")}
          {renderSimpleTable(
            table3Data,
            "3. 전기통신공사업법에 의한 전기통신공사"
          )}
          {renderSimpleTable(table4Data, "4. 소방법에 의한 소방공사 등")}
        </div>

        {/* 푸터 */}
        <div className="p-4 border-top bg-light">
          <div className="d-flex justify-content-between align-items-center">
            <div className="text-muted small">
              <span
                className="material-symbols-outlined me-1"
                style={{ fontSize: "16px" }}
              >
                info
              </span>
              행을 클릭하여 하자보증기간을 선택하세요
            </div>
            <button
              onClick={handleClose}
              className="btn btn-outline-secondary"
              style={{ borderRadius: "8px" }}
            >
              취소
            </button>
          </div>
        </div>

        <style
          dangerouslySetInnerHTML={{
            __html: `
            .warranty-row:hover {
              background-color: #f8f9fa !important;
            }
            .warranty-row:hover .badge {
              background-color: #0056b3 !important;
            }
          `,
          }}
        />
      </div>
    </Modal>
  );
};

export default WarrantyPeriodModal;
